import {create} from 'zustand'
import {devtools} from 'zustand/middleware'

import { 
    createDemoAccess, getApplicationCard, getApplicationCheckPhone, getApplications, getApplicationsPromo, 
    sendEmailClientInfo, sendTelegramAppPromo, sendTelegramClientDecisionLearn, sendTelegramClientDemoInfo, sendTelegramClientInfo, 
    sendTelegramEducationPlan, sendTelegramClientNewYear, sendTelegramClientRepeat, 
    sendTelegramClientTrainingBegun, setApplicationCardSave, downloadFile,
    putApplicationBlackList,
    putApplicationPromoArchive
} from './api'

import {
    IApplicationsState, IApplicationsActions, IApplicationsList, IApplicationsPromoList, IApplicationsFilter, IApplicationsStatistics,
    IApplicationFotmSendedData,
    IApplicationsPromoFilter
} from './state.types'
import { createLatestRequestController } from '../latest-request'


export const initialStateApplications: IApplicationsState = {
    applicationsStatistics: {} as IApplicationsStatistics,

    isLoadingCard: false,
 
    applications: {
        isLoading: false,

        items: [] as IApplicationsList[],
        tableColumns: [],
        pageSize: 0,
        currentPage: 0,

        totalCount: 0,
        new: 0,
        delayedCall: 0,
        executionContract: 0,
    },

    applicationsPromo: {
        isLoading: false,

        items: [] as IApplicationsPromoList[],
        totalCount: 0,
        pageSize: 0,
        currentPage: 0
    }
}

const applicationsListRequest = createLatestRequestController()
const applicationsPromoRequest = createLatestRequestController()

/** Хранилище страницы - Заявки */
export const useApplications = create<IApplicationsState & IApplicationsActions>()(devtools((set) => ({
    ...initialStateApplications,

    /** Сброс хранилища, до начального состояния */
    clearStateApplications: () => {
        applicationsListRequest.invalidate()
        applicationsPromoRequest.invalidate()
        set(initialStateApplications)
    },
    
    /** Сброс хранилища промо-заявки */
    clearStateApplicationsPromo: () => {
        applicationsPromoRequest.invalidate()
        set((state) => ({
            applicationsPromo: {
                ...state.applicationsPromo,
                items: [],
                totalCount: 0,
                pageSize: 0,
                currentPage: 0,
                archiveCount: 0
            }
        }))
    },



    /** Получение списка заявок */
    actionGetApplications: async (pageNumber: number, search: string, filter?: IApplicationsFilter, isShowLoading: boolean = true) => {
        const request = applicationsListRequest.start()

        set((state) => ({ 
            applications: { 
                ...state.applications, 
                isLoading: isShowLoading 
            } 
        }))


        /** Выполняем запрос */
        const response = await getApplications(pageNumber, search, filter, !isShowLoading, request.signal)
        if (!request.isCurrent()) return response
        request.finish()

        // Проверка статуса
        if (response.status === 200) {
            set((state) => ({
                applications: {
                    ...state.applications,
                    items: response.data!.items,
                    tableColumns: response.data!.tableColumns || [],
                    pageSize: response.data!.pageSize,
                    currentPage: response.data!.currentPage,

                    totalCount: response.data!.totalCount,
                    new: response.data!.new,
                    delayedCall: response.data!.delayedCall,
                    executionContract: response.data!.executionContract,
                }
            }))
        }

        set((state) => ({ 
            applications: { 
                ...state.applications, 
                isLoading: false 
            } 
        }))

        return response
    },

    /** Добавление (Удаление) заявки из чёрного листа */
    actionSetApplicationBlackList: async (applicationID: number, action: string) => {

        /** Выполняем запрос */
        const response = await putApplicationBlackList(applicationID, action)
        
        // Проверка статуса
        if (response.status === 200) {}

        return response
    },

    /** Получение списка промо-заявок (МАКПП) */
    actionGetApplicationsPromo: async (pageNumber: number, search: string, filter?: IApplicationsPromoFilter) => {
        const request = applicationsPromoRequest.start()

        set((state) => ({
            applicationsPromo: {
                ...state.applicationsPromo, 
                isLoading: true
            }}
        ))

        /** Выполняем запрос */
        const response = await getApplicationsPromo(pageNumber, search, filter, request.signal)
        if (!request.isCurrent()) return response
        request.finish()

        // Проверка статуса
        if (response.status === 200) {
            set((state) => ({
                applicationsPromo: {
                    ...state.applicationsPromo, 
                    items: response.data!.data,
                    totalCount: response.data!.totalCount,
                    pageSize: response.data!.pageSize,
                    currentPage: response.data!.currentPage
                }
            }))
        }


        set((state) => ({
            applicationsPromo: {
                ...state.applicationsPromo, 
                isLoading: false
            }
        }))

        return response
    },

    /** Добавление (Удаление) заявки из архива */
    actionSetApplicationPromoArchive: async (applicationID: number, action: string) => {

        /** Выполняем запрос */
        const response = await putApplicationPromoArchive(applicationID, action)
        
        // Проверка статуса
        if (response.status === 200) {
            // set({isReloadApplications: true})
        }

        return response
    },

    /** Проверка существование заявки, по номеру телефона клиента */
    actionGetApplicationCheckPhone: async (applicationID: number, clientPhone: string) => {
        
        /** Выполняем запрос */
        const response = await getApplicationCheckPhone(applicationID, clientPhone)
        // Проверка статуса
        if (response.status === 200) {}

        return response
    },



    /** Получение данных по анкете заявки */
    actionGetApplicationCard: async (applicationID: number) => {
        set({isLoadingCard: true})

        /** Выполняем запрос */
        const response = await getApplicationCard(applicationID)
        // Проверка статуса
        if (response.status === 200) {
            
        }

        set({isLoadingCard: false})

        return response
    },

    /** Сохранение данных по анкете заявки */
    actionSetApplicationCard: async (applicationID: number, data: IApplicationFotmSendedData) => {
        set({isLoadingCard: true})

        try {
            return await setApplicationCardSave(applicationID, data)
        } finally {
            set({isLoadingCard: false})
        }
    },


    /** Скачивание учебного плана в виде файла */
    actionDownloadFile: async (dataBase: string, filePath: string, fileName: string) => {
        // set((state) => ({applications: {...state.applications, isLoading: true}}))
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const response = await downloadFile(dataBase, filePath)

        if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${fileName}`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        }

        // set((state) => ({ applications: { ...state.applications, isLoading: false } }))
        // set({ isLoadingCard: false })

        return response
    },



    /** Отправка в Telegram канал - Информация для клиента */
    actionSendTelegramClientInfo: async (applicationID: number) => {
        // set((state) => ({applications: {...state.applications, isLoading: true}}))
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const response = await sendTelegramClientInfo(applicationID)
        // if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        // if (res.message === 'OK') set({ error: null })

        // set((state) => ({applications: {...state.applications, isLoading: false}}))
        // set({isLoadingCard: false})

        return response
    },
    /** Отправка в Telegram канал - Учебный план */
    actionSendTelegramEducationPlan: async (applicationID: number) => {
        // set((state) => ({applications: {...state.applications, isLoading: true}}))
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const responce = await sendTelegramEducationPlan(applicationID)
        // if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        // if (res.message === 'OK') set({ error: null })

        // set((state) => ({applications: {...state.applications, isLoading: false}}))
        // set({isLoadingCard: false})

        return responce
    },
    /** Отправка (ДЕМО + ИНФО) в Telegram канал - Информация для клиента */
    actionSendTelegramClientDemoInfo: async (applicationID: number) => {
        // set((state) => ({applications: {...state.applications, isLoading: true}}))
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const responce = await sendTelegramClientDemoInfo(applicationID)
        // if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        // if (res.message === 'OK') set({ error: null })

        // set((state) => ({applications: {...state.applications, isLoading: false}}))
        // set({isLoadingCard: false})

        return responce
    },
    /** Отправка (ПОВТОРНЫЙ КЛИЕНТ) в Telegram канал - Информация для клиента */
    actionSendTelegramClientRepeat: async (applicationID: number) => {
        // set((state) => ({applications: {...state.applications, isLoading: true}}))
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const responce = await sendTelegramClientRepeat(applicationID)
        // if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        // if (res.message === 'OK') set({ error: null })

        // set((state) => ({applications: {...state.applications, isLoading: false}}))
        // set({isLoadingCard: false})

        return responce
    },
    /** Отправка в Telegram канал - Решение клиента обучаться */
    actionSendTelegramClientDecisionLearn: async (applicationID: number) => {
        // set((state) => ({applications: {...state.applications, isLoading: true}}))
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const responce = await sendTelegramClientDecisionLearn(applicationID)
        // if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        // if (res.message === 'OK') set({ error: null })

        // set((state) => ({applications: {...state.applications, isLoading: false}}))
        // set({isLoadingCard: false})

        return responce
    },
    /** Отправка в Telegram канал - Обучение уже началось */
    actionSendTelegramClientTrainingBegun: async (applicationID: number) => {
        // set((state) => ({applications: {...state.applications, isLoading: true}}))
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const responce = await sendTelegramClientTrainingBegun(applicationID)
        // if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        // if (res.message === 'OK') set({ error: null })

        // set((state) => ({applications: {...state.applications, isLoading: false}}))
        // set({isLoadingCard: false})

        return responce
    },
    /** Отправка в Telegram канал - Промо */
    actionSendTelegramClientNewYear: async (applicationID: number) => {
        // set((state) => ({applications: {...state.applications, isLoading: true}}))
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const responce = await sendTelegramClientNewYear(applicationID)
        // if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        // if (res.message === 'OK') set({ error: null })

        // set((state) => ({applications: {...state.applications, isLoading: false}}))
        // set({isLoadingCard: false})

        return responce
    },
    /** Отправка EMAIL - На почту клиенту */
    actionSendEmailClientInfo: async (applicationID: number, isDemo: number) => {
        // set((state) => ({applications: {...state.applications, isLoading: true}}))
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const responce = await sendEmailClientInfo(applicationID, isDemo)
        // if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        // if (res.message === 'OK') set({ error: null })

        // set((state) => ({applications: {...state.applications, isLoading: false}}))
        // set({isLoadingCard: false})

        return responce
    },
    /** Создание демо-доступа и отправка в Telegram канал - Демо доступ */
    actionCreateDemoAccess: async (applicationID: number) => {
        // set((state) => ({applications: {...state.applications, isLoading: true}}))
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const responce = await createDemoAccess(applicationID)
        // if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        // if (res.message === 'OK') set({ error: null })

        // set((state) => ({applications: {...state.applications, isLoading: false}}))
        // set({isLoadingCard: false})

        return responce
    },
    /** Отправка в Telegram канал - Промо (МАКПП) */
    actionSendTelegramAppPromo: async (applicationID: number) => {
        // set((state) => ({applications: {...state.applications, isLoading: true}}))
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const responce = await sendTelegramAppPromo(applicationID)
        // if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        // if (res.message === 'OK') set({ error: null })

        // set((state) => ({applications: {...state.applications, isLoading: false}}))
        // set({isLoadingCard: false})

        return responce
    },

}), {name: 'StateApplications'}))